import * as React from 'react';
import { Card, CardProps } from './Card';
import './Card.scss';

import { useLocation } from '../../../helpers/routing';
import { LocationState, SurveyContainerLocationState } from '../../survey-container/types';
import { getUrlSlug, isChatbotUrl, isT404PUrl } from '../../../helpers/url';
import { ButtonsWrapper } from '../../buttons-wrapper';

export const CardWrapper: React.FC<CardProps> = ({ children, ...cardProps }) => {
  const location = useLocation() as LocationState;
  const { mghUrl }: SurveyContainerLocationState = location.state || {};
  const urlSlug = getUrlSlug(mghUrl, location).toLowerCase();
  const isChatbotTheme = isChatbotUrl(urlSlug);
  const isT404PTheme = isT404PUrl(urlSlug);

  if (isChatbotTheme || isT404PTheme) {
    return <>{children}</>;
  } else {
    return (
      <ButtonsWrapper>
        <Card {...cardProps}>{children}</Card>
      </ButtonsWrapper>
    );
  }
};

export default CardWrapper;
